import { Routes, Route } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'

// Layouts
import PublicLayout from './components/layout/PublicLayout'
import AdminLayout from './components/layout/AdminLayout'
import WorkersLayout from './components/layout/WorkersLayout'

// Public Pages
import Home from './pages/public/Home'
import About from './pages/public/About'
import Ministries from './pages/public/Ministries'
import Sermons from './pages/public/Sermons'
import Events from './pages/public/Events'
import Gallery from './pages/public/Gallery'
import Contact from './pages/public/Contact'
import NewHere from './pages/public/NewHere'
import PlanVisit from './pages/public/PlanVisit'
import Blog from './pages/public/Blog'
import BlogPost from './pages/public/BlogPost'
import Discipleship from './pages/public/Discipleship'
import ConnectCard from './pages/public/ConnectCard'
import Unsubscribe from './pages/public/Unsubscribe'

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin'
import Dashboard from './pages/admin/Dashboard'
import HeroManager from './pages/admin/HeroManager'
import EventsManager from './pages/admin/EventsManager'
import SermonsManager from './pages/admin/SermonsManager'
import MinistriesManager from './pages/admin/MinistriesManager'
import LeadershipManager from './pages/admin/LeadershipManager'
import MediaLibrary from './pages/admin/MediaLibrary'
import SiteSettings from './pages/admin/SiteSettings'
import FormSubmissions from './pages/admin/FormSubmissions'
import UsersManager from './pages/admin/UsersManager'
import GalleryManager from './pages/admin/GalleryManager'
import BlogManager from './pages/admin/BlogManager'
import WorkersManager from './pages/admin/WorkersManager'
import DepartmentsManager from './pages/admin/DepartmentsManager'
import AnnouncementsManager from './pages/admin/AnnouncementsManager'
import SchedulesManager from './pages/admin/SchedulesManager'
import ResourcesManager from './pages/admin/ResourcesManager'

// Workers Portal Pages
import WorkersLogin from './pages/workers/WorkersLogin'
import WorkersRegister from './pages/workers/WorkersRegister'
import WorkersDashboard from './pages/workers/WorkersDashboard'
import WorkersSchedule from './pages/workers/WorkersSchedule'
import DepartmentPage from './pages/workers/DepartmentPage'
import WorkersResources from './pages/workers/WorkersResources'
import WorkersSongs from './pages/workers/WorkersSongs'
import SongsManage from './pages/workers/SongsManage'

// Protected Routes
import ProtectedRoute from './components/common/ProtectedRoute'
import WorkersRoute from './components/common/WorkersRoute'

function App() {
  return (
    <AnimatePresence mode="wait">
      <Routes>
        {/* Public Routes */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/ministries" element={<Ministries />} />
          <Route path="/sermons" element={<Sermons />} />
          <Route path="/events" element={<Events />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/new-here" element={<NewHere />} />
          <Route path="/discipleship" element={<Discipleship />} />
          <Route path="/plan-your-visit" element={<PlanVisit />} />
          <Route path="/connect" element={<ConnectCard />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
        </Route>

        {/* Admin Login (no layout) */}
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* Admin Routes (Protected) */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="hero" element={<HeroManager />} />
          <Route path="events" element={<EventsManager />} />
          <Route path="sermons" element={<SermonsManager />} />
          <Route path="ministries" element={<MinistriesManager />} />
          <Route path="leadership" element={<LeadershipManager />} />
          <Route path="media" element={<MediaLibrary />} />
          <Route path="settings" element={<SiteSettings />} />
          <Route path="submissions" element={<FormSubmissions />} />
          <Route path="users" element={<UsersManager />} />
          <Route path="gallery" element={<GalleryManager />} />
          <Route path="blog" element={<BlogManager />} />
          <Route path="workers" element={<WorkersManager />} />
          <Route path="departments" element={<DepartmentsManager />} />
          <Route path="announcements" element={<AnnouncementsManager />} />
          <Route path="schedules" element={<SchedulesManager />} />
          <Route path="resources" element={<ResourcesManager />} />
        </Route>

        {/* Workers Portal Auth (no layout) */}
        <Route path="/workers/login" element={<WorkersLogin />} />
        <Route path="/workers/register" element={<WorkersRegister />} />

        {/* Workers Portal (Protected) */}
        <Route
          path="/workers"
          element={
            <WorkersRoute>
              <WorkersLayout />
            </WorkersRoute>
          }
        >
          <Route index element={<WorkersDashboard />} />
          <Route path="schedule" element={<WorkersSchedule />} />
          <Route path="departments/:slug" element={<DepartmentPage />} />
          <Route path="resources" element={<WorkersResources />} />
          <Route path="songs" element={<WorkersSongs />} />
          <Route path="songs/manage" element={<SongsManage />} />
        </Route>
      </Routes>
    </AnimatePresence>
  )
}

export default App
